module.exports = "pegasus/assets/map-bg.jpg";